import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    updates: {
        version: 0,
        release: 0,
        contentAR: "",
        contentEN: "",
        attachment : ""
    }
};

const updatesSlice = createSlice({
    name: "updates",
    initialState,
    reducers: {
        setUpdates: (state, action) => {
            state.updates = action.payload;
        },
        resetUpdates: (state) => {
            state.updates = initialState.updates;
        }
    }
});

export const { setUpdates, resetUpdates } = updatesSlice.actions;
export default updatesSlice.reducer;
